import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AdesaoService } from 'src/app/services/adesao.service';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { MovimentacoesPartService } from 'src/app/services/movimentacoes-part.service';
import { ToastrService } from 'ngx-toastr';
import { finalize, take } from 'rxjs/operators';
import { ContribuicaoComponent } from './contribuicao/contribuicao.component';
import { PortabilidadeComponent } from './portabilidade/portabilidade.component';
import { RecebimentosService } from 'src/app/services/recebimentos.service';
import { SeguroAdesaoServices } from 'src/app/services/seguro/seguro-adesao.service';
import { AporteComponent } from './aporte/aporte.component';
import { DatePipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { GraficoComponent } from './grafico/grafico.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterModule, ContribuicaoComponent, CommonModule, PortabilidadeComponent, AporteComponent, DatePipe, CurrencyPipe, DecimalPipe, GraficoComponent]
})
export class HomeComponent implements OnInit {

  @ViewChild(ContribuicaoComponent,{static:false}) contribComponente: ContribuicaoComponent;
  @ViewChild(PortabilidadeComponent,{static:false}) portabilidadeComponente: PortabilidadeComponent;


  modalType: string = 'aporte';
  modalStep: string = 'aporte_1';
  dataUltimaAtualizacao:Date;
  saldoEntrada:string;
  saldoSaida:string;
  saldoRentabilidade:string;
  saldoFinal:string;
  valorContribuicao:string;

  cobrancas: any[] = [];

  loading: boolean = false;
  dashLiberada: boolean = false;

  /** Eleições **/
  eleicaoHabilitadoAuto: boolean = false;
  temEleicao: boolean = false;
  eleicaoFusan: string = "";
  eleicaoFusanMsg: string = "";
  podeVotarFusan: boolean = false;

  elegivelSeguro: number = 0;
  exibeBannerSeguro: boolean = true;

  credenciais: any = null;

  constructor(private router: Router, private adesao: AdesaoService, private autenticacao: AutenticacaoService, private toastr: ToastrService, private movimentacoesPart: MovimentacoesPartService, private recebimentos: RecebimentosService, private seguroAdesao: SeguroAdesaoServices) {

    this.credenciais = this.autenticacao.getCredenciais();

  }

  ngOnInit() {

    this.verificaAdesaoFinalizada();
    this.verificarElegibilidadeSeguro();

    //Redefine a modal ao fecha-la
    $('#homeModal').on('hidden.bs.modal', ()=>{
        this.modalType = "";
        this.modalStep = "";
    });

  }


  verificaAdesaoFinalizada(){

    let cpf = this.autenticacao.getCredenciais().cpf;

    this.adesao
        .verificaAdesaoFinalizada(cpf)
        .pipe(
          finalize(() => {this.loading = false})
        )
        .subscribe(
          (finalizada: boolean)=>{

            if(!finalizada){

              this.dashLiberada = false;
              alert('Adesão não finalizada, redirecionando para a adesão...')
              window.location.href = "/logado/adesao";

            }else{

              this.dashLiberada = true;

              this.verificaEleicao();
              this.listarCobrancas();
              this.buscaDadosSaldos();
            }
          },
        )
  }


  verificaEleicao(){

    this.movimentacoesPart
    .verificaEleicao()
    .subscribe(
      (res:any)=>{

        this.eleicaoHabilitadoAuto = res.habilitadoAuto;
        this.temEleicao = res.temEleicaoFusan;

        this.eleicaoFusan = res.fusan;
        this.eleicaoFusanMsg = res.fusanMsg;
        this.podeVotarFusan = res.podeVotarFusan;

      }
    )
  }

  verificarElegibilidadeSeguro(){

    this.seguroAdesao
        .ElegibilidadeAdesao()
        .pipe(
          take(1)
        )
        .subscribe(
          (elegivel: number) => {
            this.elegivelSeguro = elegivel;
            localStorage.setItem("elegivelSeguro", elegivel.toString());
          }
        )

  }

  buscaDadosSaldos(){
    this.movimentacoesPart
        .buscaDadosSaldos()
        .subscribe(
          (res:any)=>{
            this.dataUltimaAtualizacao = res.dataUltimaMov;
            this.saldoEntrada = res.saldoEntrada;
            this.saldoSaida = res.saldoSaida;
            this.saldoRentabilidade = res.saldoRentabilidade;
            this.saldoFinal = res.saldoFinal;
            this.valorContribuicao = res.valorContribuicao;
          }
        )
  }

  listarCobrancas(){

    this.recebimentos
        .listarCobrancasCardHome()
        .subscribe(
          (res: any[]) => {
            this.cobrancas = res;
            this.setaStatus();
          }
        )
  }

  setaStatus(){
    let dataAtual = new Date();
    this.cobrancas.forEach(item => {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      
      const dataVencimento = new Date(item.DTA_VENC.replace(/-/g, '\/'))
      dataVencimento.setHours(0, 0, 0, 0);

      if(dataVencimento < hoje && item.DTA_PGTO === null){

        item.STATUS = "Pendente";
        item.CLASSE = "status red"

      }else if(item.DTA_PGTO !== null){

        item.STATUS =  "Pago"
        item.CLASSE = "status gray"

      }else{

        item.STATUS =  "A vencer"
        item.CLASSE = "status blue"
      }

    });
  }


  closeModal(tipoModal){

    switch(tipoModal){
      case "contrib":
        this.contribComponente.modalStep = "contrib_1"
      break;
      case "portab" :
        this.portabilidadeComponente.modalStep = "portab_1"
      break
      default:
        this.modalStep = "aporte_1";
      break;
    }

  }

}
